import React from 'react'
export type SortableContextType = {
  sortableId?: string
  sortableKey?: string
  onDropOutside?: () => void
}
export const SortableContext: React.Context<SortableContextType> =
  React.createContext<SortableContextType>({})
